/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	PREMIUM_EDITION,
	STANDARD_EDITION,
	getEdition,
	toEdition,
} from '@jira/platform__application-editions/src/edition.tsx';
import { JIRA_PRODUCT_DISCOVERY } from '@jira/platform__application-editions/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { useIsEnterpriseEdition as useIsEnterpriseEditionStore } from './PolarisEntitlementStore.tsx';

export const useIsEnterpriseEdition = (): boolean => {
	return useIsEnterpriseEditionStore();
};

export const useIsPremiumEdition = (): boolean => {
	const appEditions = useAppEditions();

	const jpdEdition = getEdition(JIRA_PRODUCT_DISCOVERY, appEditions);

	// TODO: POL-10089 use entitlements instead of the edition when it will be available
	return jpdEdition === toEdition(PREMIUM_EDITION);
};

export const useIsStandardEdition = (): boolean => {
	const appEditions = useAppEditions();

	const jpdEdition = getEdition(JIRA_PRODUCT_DISCOVERY, appEditions);

	return jpdEdition === toEdition(STANDARD_EDITION);
};

export const useIsViewPermissionsEnabled = (): boolean => {
	const isPremium = useIsPremiumEdition();

	return isPremium;
};

export const useIsCrossProjectViewsEnabled = (): boolean => {
	const isPremium = useIsPremiumEdition();

	return isPremium;
};

export const useIsConnectionsEnabled = (): boolean => {
	const isPremium = useIsPremiumEdition();

	return isPremium;
};
